export default __webpack_public_path__ + "static/media/mobile-desktop.8389fc29.svg";